<script lang="ts">
    import {Component, Prop, toNative, Setup} from 'vue-facing-decorator'
    import __ClientAutocomplete, {
        ClientAutocomplete as _ClientAutocomplete,
    } from '@/components/account/modals/newOrderRequest/ClientAutocomplete.vue'
    import {PHONE_REGEXP} from '@/utils/helpers'

    @Component({mixins: [__ClientAutocomplete]})
    export class CompanyAutocomplete extends _ClientAutocomplete {
        @Prop({default: () => [null]}) types
        @Prop({default: 'name'}) mainSearchParam
        @Prop({default: false, type: Boolean}) phoneSearch
        @Prop({default: false, type: Boolean}) activeOnly

        @Setup(() => useLocalized()) localized: Function

        companyPhoneString = null
        cancelTokenSources = []

        async loadCompaniesByPhone(type) {
            try {
                const cancelTokenSource = this.$axios.CancelToken.source()
                this.cancelTokenSources.push(cancelTokenSource)

                const rq = {
                    ...(type && {type}),
                    shortResponse: true,
                    phone: this.searchInput,
                    ...(this.activeOnly && {active: true}),
                    limit: 10,
                }

                return await this.$api.companies.get(rq, cancelTokenSource.token)
            } catch (e) {
                this.$toast.error(this.$t('error_message.load_error'))
            }
        }

        async loadCompaniesByMainParam(type) {
            try {
                const cancelTokenSource = this.$axios.CancelToken.source()
                this.cancelTokenSources.push(cancelTokenSource)

                const rq = {
                    ...(type && {type}),
                    shortResponse: true,
                    [this.mainSearchParam]: this.searchInput,
                    ...(this.activeOnly && {active: true}),
                    limit: 10,
                }

                return await this.$api.companies.get(rq, cancelTokenSource.token)
            } catch (e) {
                this.$toast.error(this.$t('error_message.load_error'))
            }
        }

        async loadClients() {
            try {
                this.clients = []
                this.cancelTokenSources.forEach(cancelTokenSource => cancelTokenSource.cancel())
                this.cancelTokenSources = []
                this.isLoadingClients = true
                this.companyPhoneString = PHONE_REGEXP.test(this.searchInput) ? this.searchInput : null

                const promises = []

                if (this.companyPhoneString && this.phoneSearch) {
                    promises.push(...this.types.map(type => this.loadCompaniesByPhone(type)))
                }
                promises.push(...this.types.map(type => this.loadCompaniesByMainParam(type)))

                const result = (await Promise.all(promises))
                    .map(el => el.companies)
                    .flat()
                    .sort((a, b) => a.name.localeCompare(b.name))

                if (this.itemValue) {
                    this.clients = result.filter(el => el[this.itemValue])
                } else {
                    this.clients = result
                }
            } catch (e) {
                /* empty */
            } finally {
                this.isLoadingClients = false
            }
        }

        inputText(val) {
            const phone = val?.phones?.find(p => p.includes(this.companyPhoneString)) || null
            return this.localized(val?.name) + (phone ? ` (${phone})` : '') || null
        }
    }

    export default {...toNative(CompanyAutocomplete), ssrRender: __ClientAutocomplete.ssrRender}
</script>
